import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { OrderCreationNotificationAdminComponent } from './order-creation-notification-admin.component';
import { EditorModule } from 'primeng';

const routes: Routes = [
  {
    path: '',
    component: OrderCreationNotificationAdminComponent,
    data: { title: 'Order Creation Notification Admin' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrderCreationNotificationAdminRoutingModule {}

@NgModule({
  imports: [
    OrderCreationNotificationAdminRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    EditorModule,
  ],
  declarations: [OrderCreationNotificationAdminComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OrderCreationNotificationAdminModule {}
